export enum DprAttachmentType {
  Activity = 1,
  ParallelActivity,
  Weather,
  Hse,
  Personnel,
  Consumable,
  Summary,
  Appendix,
  SignedReport,
  Progress,
  Hidden,
}
